// extracted by mini-css-extract-plugin
export default {"sortIconText":"column-sort-icon-module__sortIconText--Ui_P7"};